import { HTTP } from "@/common/http-common";
import properties from "@/properties";

const RESOURCE_NAME = "entities/activities";

export default {
  async getAllLinks(options = {}) {
    const response = await HTTP.get(`${RESOURCE_NAME}/links`, options);
    return response.data;
  },

  async getAll(options = {}) {
    const response = await HTTP.get(`${RESOURCE_NAME}`, options);
    return response.data;
  },

  async get(id) {
    return (await HTTP.get(`${RESOURCE_NAME}/${id}`)).data;
  },

  async downloadActivityFile(id) {
    return HTTP.get(`${RESOURCE_NAME}/${id}/file`, {
      responseType: "blob",
    });
  },

  getActivityContentUrl(id) {
    return `${properties.SERVER_URL}/${RESOURCE_NAME}/${id}/content`;
  },

  async downloadActivityThumbnail(id) {
    return HTTP.get(`${RESOURCE_NAME}/${id}/thumbnail`, {
      responseType: "blob",
    });
  },

  async save(entity) {
    if (entity.id) {
      return (await HTTP.put(`${RESOURCE_NAME}/${entity.id}`, entity)).data;
    } else {
      return (await HTTP.post(`${RESOURCE_NAME}`, entity)).data;
    }
  },

  async saveContent(entity) {
    return (await HTTP.put(`${RESOURCE_NAME}/${entity.id}/content`, entity))
      .data;
  },

  async delete(id) {
    return await HTTP.delete(`${RESOURCE_NAME}/${id}`);
  },
};
